
import { defineComponent } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import Calendar from "primevue/calendar";

export default defineComponent({
  name: "MessageBox",
  components: {
    Dialog,
    Button,
    InputText,
    Dropdown,
    Calendar
  },
  data() {
    return {
      visible: true,
      input: "",
    };
  },
  mounted() {
    this.input = this.inputValue || "";
  },
  computed: {
    isInputDropdown(): boolean {
      return this.inputType?.toUpperCase() === "DROPDOWN";
    },
    isInputDate(): boolean {
      return this.inputType?.toUpperCase() === "DATE";
    },
    isInputText(): boolean {
      return this.inputType?.toUpperCase() === "TEXT";
    },
    isInputNumber(): boolean {
      return this.inputType?.toUpperCase() === "NUMBER";
    },
    iconClass(): string {
      let iconClass = "";
      switch (this.icon) {
        case "INFO":
          iconClass = "pi pi-exclamation-triangle mr-3";
          break;
        case "WARNING":
          iconClass = "pi pi-exclamation-triangle mr-3";
          break;
        default:
      }
      return iconClass;
    },
    messageLines(): any {
      return this.message?.includes("\r\n")
        ? this.message?.split("\r\n")
        : null;
    },
  },
  methods: {
    primaryButtonClick() {
      if(this.inputType) {
        this.$emit("primaryButtonClick", this.input);
      } else {
        this.$emit("primaryButtonClick");
      }
    },
    cancelButtonClick() {
      this.$emit("cancelButtonClick");
    },
  },
  props: {
    showDialog: Boolean,
    header: String,
    icon: String,
    message: String,
    messageItems: Array,
    primaryButton: String,
    cancelButton: String,
    options: Object,
    optionLabel: String,
    optionValue: String,
    inputValue: String,
    inputType: String,
    inputLabel: String,
  },
});
